import { render } from "./OcMentionMembers.vue?vue&type=template&id=1a41888b&scoped=true"
import script from "./OcMentionMembers.vue?vue&type=script&lang=js"
export * from "./OcMentionMembers.vue?vue&type=script&lang=js"

import "./OcMentionMembers.vue?vue&type=style&index=0&id=1a41888b&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a41888b"]])

export default __exports__